export interface ITerritory {
  Region: string;
  Reference: string;
  DisplayName: string;
}

export enum RestrictionSchemeType {
  AllowOnly,
  DenyOnly,
}
